import { createSlice } from "@reduxjs/toolkit";
import { initialFilter } from "../../pages/payment-method/PMUIHelpers";

const initialPaymentMethodsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  paymentMethodForEdit: undefined,
  lastError: null,
  filters: initialFilter
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const paymentMethodSlice = createSlice({
  name: "paymentMethods",
  initialState: initialPaymentMethodsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getPaymentMethodById
    paymentMethodFetched: (state, action) => {
      state.actionsLoading = false;
      state.paymentMethodForEdit = action.payload.paymentMethodForEdit;
      state.error = null;
    },
    // findPaymentMethods
    paymentMethodsFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = items;
      state.totalCount = total_items;
    },
    // getAllPaymentMethod
    paymentMethodAllFetched: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.all = action.payload.all;
    },
    // createPaymentMethod
    paymentMethodCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.paymentMethod);
    },
    // updatePaymentMethod
    paymentMethodUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map((entity) => {
        if (entity.id === action.payload.paymentMethod.id) {
          return action.payload.paymentMethod;
        }
        return entity;
      });
    },
    paymentMethodFilter: (state, action) => {
      state.listLoading = false
      state.error = null
      state.filters = action.payload
    }
  },
});
